import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import arrowDown from '../../pages/assets/arrowDown.svg'

import { BiChevronDown } from 'react-icons/bi';

const CustomDatePicker = ({ selectedDate, setSelectedDate, eventDateError }) => {
  return (
    <div className='relative w-full flex'>
     <div className='w-full px-[21px] flex flex-1 items-center justify-between sm:justify-start'>
  <DatePicker
    selected={selectedDate}
    onChange={(date) => setSelectedDate(date)}
    dateFormat="dd - MM - yyyy"
    placeholderText="Select date"
    className={`w-full h-[45px] rounded-[80px] bg-transparent outline-none text-base font-normal ${eventDateError?'placeholder:text-[#EB0728]':' placeholder:text-[#707070]'} `}
    maxDate={new Date()} // Prevent future dates
    minDate={new Date('1900-01-01')} // Allow selection from 1900 onwards
    showYearDropdown // Enable year dropdown
    scrollableYearDropdown // Allow scrolling through years
    yearDropdownItemNumber={100} // Show 100 years in dropdown
    showMonthDropdown // Enable month selection
  />
</div>
    </div>
  );
};

export default CustomDatePicker;
